import { render, staticRenderFns } from "./SignAbyPoint.vue?vue&type=template&id=306165d9&scoped=true&"
import script from "./SignAbyPoint.vue?vue&type=script&lang=js&"
export * from "./SignAbyPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306165d9",
  null
  
)

export default component.exports